{
  "name": "configuration-renderer-minimal-example",
  "version": "2.14.1",
  "private": true,
  "homepage": ".",
  "type": "module",
  "dependencies": {
    "@4pace-print-button-area/core": "^1.3.0",
    "@emotion/cache": "^11.14.0",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@mdi/js": "^7.4.47",
    "@mdi/react": "^1.6.1",
    "@mui/icons-material": "7.3.11",
    "@mui/material": "7.3.11",
    "@mui/system": "7.3.11",
    "@mui/utils": "7.3.11",
    "@mui/x-date-pickers": "8.29.0",
    "@mui/x-tree-view": "8.29.0",
    "@plansoft-configuration-renderer/components": "12.103.1",
    "@plansoft-configuration-renderer/configuration-api": "12.103.1",
    "@plansoft-configuration-renderer/debug": "12.103.1",
    "@plansoft-configuration-renderer/events": "12.103.1",
    "@plansoft-configuration-renderer/framework": "12.103.1",
    "@plansoft-configuration-renderer/gateway": "12.103.1",
    "@plansoft-configuration-renderer/layout": "12.103.1",
    "@plansoft-configuration-renderer/localization": "12.103.1",
    "@plansoft-configuration-renderer/styles": "12.103.1",
    "@plansoft-configuration-renderer/utils": "12.103.1",
    "@redux-devtools/extension": "^4.0.0",
    "@tanstack/query-core": "5.101.0",
    "@tanstack/react-query": "5.101.0",
    "axios": "^1.18.1",
    "bootstrap": "^4.6.2",
    "events": "^3.3.0",
    "file-saver": "^2.0.5",
    "i18n-iso-countries": "^7.14.0",
    "i18next": "26.3.1",
    "jotai": "2.20.1",
    "jszip": "^3.10.1",
    "luxon": "^3.7.2",
    "material-react-table": "^3.2.1",
    "prop-types": "^15.8.1",
    "qs": "^6.15.3",
    "react": "19.2.7",
    "react-dom": "19.2.7",
    "react-ga4": "^3.0.1",
    "react-helmet-async": "^3.0.0",
    "react-i18next": "17.0.8",
    "react-material-ui-carousel": "^3.4.2",
    "react-redux": "^9.2.0",
    "react-router": "^5.3.4",
    "react-router-dom": "^5.3.4",
    "react-world-flags": "^1.6.0",
    "reactstrap": "^8.10.1",
    "redux": "^5.0.1",
    "redux-thunk": "^3.1.0",
    "reselect": "^5.2.0",
    "rss-parser": "^3.13.0",
    "uuid": "^14.0.1",
    "web-vitals": "^5.2.0"
  },
  "devDependencies": {
    "@4pace/sync-deps": "0.9.2",
    "@plansoft-configuration-renderer/eslint-config-react": "12.103.1",
    "@rushstack/eslint-patch": "^1.16.1",
    "@storybook/react-vite": "10.4.6",
    "@tanstack/eslint-plugin-query": "^5.96.2",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.6.1",
    "@trivago/prettier-plugin-sort-imports": "^6.0.2",
    "@types/node": "^22.19.17",
    "@types/react": "19.2.17",
    "@types/react-dom": "^19.2.3",
    "@types/react-router": "^5.1.20",
    "@types/react-router-dom": "^5.3.3",
    "@typescript-eslint/eslint-plugin": "^8.58.0",
    "@typescript-eslint/parser": "^8.58.0",
    "@vitejs/plugin-react": "^6.0.1",
    "@vitest/coverage-istanbul": "^4.1.2",
    "@vitest/ui": "^4.1.2",
    "csv-parser": "^3.2.1",
    "eslint": "^9.39.4",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.0.1",
    "eslint-plugin-storybook": "10.4.6",
    "eslint-plugin-unused-imports": "^4.4.1",
    "http-proxy-middleware": "^3.0.3",
    "jsdom": "^29.0.1",
    "lefthook": "^2.1.4",
    "prettier": "^3.8.1",
    "sass": "^1.101.0",
    "storybook": "10.4.6",
    "svgo": "^3.3.3",
    "typescript": "^5.9.3",
    "vite": "^8.0.3",
    "vite-bundle-analyzer": "^1.3.6",
    "vite-plugin-checker": "^0.12.0",
    "vite-plugin-package-version": "^1.1.0",
    "vite-plugin-svgr": "5.2.0",
    "vitest": "^4.1.2"
  },
  "scripts": {
    "start": "vite",
    "sb": "npm run storybook",
    "serve": "vite preview",
    "build": "vite build",
    "test": "vitest --run",
    "code-style": "npm run lint && npm run check-format",
    "lint": "eslint --max-warnings=0 \"src/**/*.{ts,tsx}\"",
    "check-format": "prettier --log-level warn ./src --check ./src",
    "format": "prettier --write --log-level warn ./src",
    "translate": "node scripts/translate.cjs",
    "prefix-icon-ids": "node scripts/prefix-icon-ids.mjs",
    "update-packages": "npx taze",
    "update-packages:ncu": "npx npm-check-updates --interactive --format group",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "overrides": {
    "react-material-ui-carousel": {
      "react": "$react",
      "react-dom": "$react-dom"
    }
  },
  "volta": {
    "node": "24.14.1"
  }
}
